import { axios } from '@/utils/request'
const api = {
  create:'/finance/enterpriseStatement',
}
// // 获取列表数据
// export function getSourceList (parameter) {
//   return axios({
//     url: api.create + '/list',
//     method: 'get',
//     params: parameter
//   })
// }
// 客户自费生成对账单
export function getFinanceSubmit (parameter) {
  return axios({
    url: api.create + '/financeSubmit',
    method: 'post',
    data: parameter,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export const sourceExport = api.source + '/export'